import { Stack, Card, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Scrollbar } from '../scrollbar';
import { CustomAvatar } from '../custom-avatar';
import { Strings } from '@app/constants';
import { StatusTag } from '../status-tag';

interface SubCardProps {
  name: string;
  date?: string;
  ManagerName?: string;
  status: string;
  description?: string;
  title?: string;
  promotionBy?: string;
  datePeriod?: string;
  reason?: string;
  firstName?: string;
  lastName?: string;
  joiningDate?: string;
}

const SubCard = ({
  name,
  date,
  ManagerName,
  status,
  description,
  datePeriod,
  reason,
  firstName,
  lastName,
  joiningDate,
}: SubCardProps) => {
  const theme = useTheme();
  const userName = `${firstName ?? ''} ${lastName ?? ''}`;
  return (
    <Card
      sx={{
        borderRadius: '5px',
        height: 'auto',
        m: 0.5,
      }}
    >
      <Stack justifyContent={'space-between'} flexDirection={{ md: 'row', sm: 'column' }} m={0.3}>
        <Stack direction="row" spacing={1} alignItems="center">
          <CustomAvatar name={name ?? userName} color="info" />
          <Stack>
            <Stack> {name ?? userName}</Stack>
            {status === 'Rejected' ? null : (
              <Stack direction={'row'} gap={0.3}>
                <Stack fontSize={10} color={theme.palette.grey[600]}>
                  {Strings.dashboard.selectionDate}
                </Stack>
                <Stack mr={2} fontSize={10} width={100}>
                  {datePeriod ?? joiningDate}
                </Stack>
              </Stack>
            )}
          </Stack>
        </Stack>

        <Stack gap={0.6}>
          <Typography textAlign={'end'} mt={description ? 1 : 0.3}>
            <StatusTag status={status} />
          </Typography>
          {status === 'Rejected' ? null : (
            <Stack direction={'row'} gap={0.5}>
              <Stack fontSize={10} color={theme.palette.grey[600]}>
                {`${Strings.dashboard.interviewedBy}:`}
              </Stack>
              <Stack fontSize={10} fontWeight={600}>
                {ManagerName}
              </Stack>
            </Stack>
          )}
        </Stack>
      </Stack>
      <Stack ml={1} mt={0.5} fontSize={10} width={290}>
        {status === 'Rejected' ? reason : null}
      </Stack>
    </Card>
  );
};

interface MainCardProps {
  title?: string;
  subCards?: SubCardProps[];
  height?: string | number;
  iconImg?: any;
}

const SelectedCandidatesCard = ({ title, subCards, height }: MainCardProps) => {
  return (
    <Stack
      sx={{
        height,
        width: { md: '100%', sm: '100%' },
        borderRadius: '5px',
        overflow: 'hidden',
        mb: 2,
      }}
    >
      {title && (
        <Typography
          fontWeight={700}
          fontSize={17}
          sx={{
            paddingLeft: 1,
            marginTop: 1,
          }}
        >
          {title}
        </Typography>
      )}
      <Scrollbar>
        {subCards?.map((subCard, index) => (
          <SubCard key={index} {...subCard} />
        ))}
      </Scrollbar>
    </Stack>
  );
};

export { SelectedCandidatesCard };
